/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as RankingTwoWayHorizontalBarSpec } from '../../../../layer/preset/bar/rankingTwoWayHorizontalBar';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface RankingTwoWayHorizontalBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type RankingTwoWayHorizontalBarLayerType = StandardChartLayerSpec &
  RankingTwoWayHorizontalBarSpec &
  RankingTwoWayHorizontalBarLayerTypeWithFields;

// 创建排名双向条形图数据类型验证器
const validateRankingTwoWayHorizontalBarDataTypes = createDataTypeValidator(
  'rankingTwoWayHorizontalBar',
  [
    { field: 'x', type: 'number' },
    { field: 'x2', type: 'number' },
    { field: 'y', type: 'string' }
  ]
);

// 创建排名双向条形图编码验证器
const validateRankingTwoWayHorizontalBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'x2' },
  { field: 'y' }
]);

// 创建并导出排名双向条形图处理器
export const rankingTwoWayHorizontalBar = createLayerProcessor<RankingTwoWayHorizontalBarLayerType>(
  'rankingTwoWayHorizontalBar',
  validateRankingTwoWayHorizontalBarEncoding,
  validateRankingTwoWayHorizontalBarDataTypes
);
